import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { contactUs } from "./Api";

// ? Initial State
export const initialState = {
  marriageDetails: [],
};

// Async thunk action for user login

export const updateContactDetails = createAsyncThunk(
  "contactus/updateContactDetails",
  async (data) => {
    const response = await contactUs(data);
    return response.data;
  }
);

const ContactUsSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

// Export the actions and reducer
export default ContactUsSlice.reducer;
